import { Component, ViewChild, Input, Output, EventEmitter, Inject } from '@angular/core';
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatDialogRef } from '@angular/material';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { Subject } from "rxjs/Subject";
import { DOCUMENT } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../core/animations';

import { FuseConfirmDialogComponent } from '../../../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { EmailPopupComponent } from '../../../email-popup/emailPopup.component';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';

/** Local file */

import { spekwo, spekWalk, toastMsg, toolTip, paginationForCustomTable, itemsPerPage } from '../../../../../utils/index';

/** Query file */
import { WalkCallQueryService, ReportReviewQueryService } from '../../../../../queryFiles/index';

import { ToastComponent } from '../../../../../common/toast.component';
import { EditComponent } from './edit/edit.component';
import { printDialogComponent } from '../../../../printDialog/printDialog.component';

/**Service files */
import { SolutionFormService } from '../../../solutionForm.service';
import { EcommerceOrderService } from '../../../../order/order.service';

@Component({
    selector: 'list-reports',
    templateUrl: './listReport.component.html',
    styleUrls: ['./listReport.component.scss'],
    animations: fuseAnimations,
})

export class ListReportComponent {

    @Input()
    allReviewReports: ReviewReport[];
    @Input()
    allReviewReports1: ReviewReport[];
    @Input()
    allSubCategories: ReviewReport[];
    @Input()
    checkBoxCategories: ReviewReport[];
    @Input()
    existingCategories: Categories[];

    @Output() callParentApi: EventEmitter<any> = new EventEmitter();
    @Output() callParentAfterDelete: EventEmitter<any> = new EventEmitter();

    categories = [];
    solutionEstimateEmails = [];
    walkDate: String;
    insReportId: string;
    solEmail: string;
    orderEmail: string
    currentOrderId: number;
    forTotalCost: number = 0;
    subjectPropertyAddress: string;

    displayedColumns = ['category', 'subCategory', 'summary', 'itemNumber', 'cost', 'buttons'];
    enableApproved: boolean = false;
    disableAlter: boolean = true;
    showDragSave: boolean = false;
    isLoading: boolean = false;

    spekwoValues: {};
    spekwoWalkValues = spekWalk;
    toastMsg = toastMsg;
    toolTip = toolTip;

    dataSource: MatTableDataSource<ReviewReport>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) reviewSort: MatSort;

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    emailConfirmRef: MatDialogRef<ConfirmDialogComponent>;

    dialogRef: any;
    orderResponse: any;

    enableApprovedSubscription: Subscription;
    insReportIdChangeSubscription: Subscription;
    solutionEmailChangesSubscription: Subscription;
    buyerPropertyChangesSubscription: Subscription;
    deleteWCCategorySubscription: Subscription;
    approveWCRRSubscription: Subscription;
    alterWCRRSubscription: Subscription;
    updateWCRRSubscription: Subscription;

    pageNumberForReview: number;// for which page we are currently in
    dragIndexForReview: number;// for identifying dragIndex based on paginator value
    page: number = 1;

    // Pagination 
    pagination = paginationForCustomTable;
    initalLoad = itemsPerPage; //Initial data load per page

    selectedId: string = ''; //To find drag index to highlight row
    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,
        /**Query file */
        public walkCallQueryService: WalkCallQueryService,
        public reportReviewQueryService: ReportReviewQueryService,

        /** Local component */
        public toastComponent: ToastComponent,

        /** Service files */
        private solutionFormService: SolutionFormService,
        private orderService: EcommerceOrderService,

        @Inject(DOCUMENT) private document: Document
    ) {
        this.spekwoValues = spekwo;
    }

    ngOnInit() {

        this.forTotalCost = 0; // total cost after saving
        this.dragIndexForReview = 0;// initially set to 0

        this.categories = this.existingCategories;

        /**Get walk date */
        this.walkDate = this.existingCategories.length > 0 ?
            new Date(this.existingCategories[0].callDate).toDateString() : new Date().toDateString();

        // get current order from params
        this.route.params.subscribe(params => {
            this.currentOrderId = Number.parseInt(params.id);
            this.getOrderDetails();
        });

        //get Inspection report  id
        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(data => {
                this.insReportId = data && data.insReportId;
            })

        //Solution estiamtion email
        this.solutionEmailChangesSubscription =
            this.solutionFormService.solutionEmailChanges.subscribe(data => {

                this.solEmail = data ? data : '';
                //console.log('solEmail', this.solEmail);
            })

        //get subjectProperty address.
        this.buyerPropertyChangesSubscription = this.solutionFormService.buyerPropertyChanges.subscribe(data => {
            this.subjectPropertyAddress = data;
        })

        // Assign the data to the data source for the table to render
        this.dataSource = new MatTableDataSource(this.allReviewReports);
        this.dataSource.sort = this.reviewSort;

        //calculating total cost
        this.allReviewReports.forEach(data => {
            this.forTotalCost = Number(this.forTotalCost) + Number(data.totalCost);
        })

        //Enabled approved if anything yet to be  approved
        this.enableApprovedSubscription =
            this.solutionFormService.isApproveChange.subscribe(data => {
                this.enableApproved = data == 'yes' ? false : true;
            })

        //Check order status -To hide "Alter solution" button if client reviewed
        this.checkOrderStatus();
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.reviewSort;
    }

    ngOnDestroy() {
        this.enableApprovedSubscription && this.enableApprovedSubscription.unsubscribe();
        this.solutionEmailChangesSubscription && this.solutionEmailChangesSubscription.unsubscribe();
        this.insReportIdChangeSubscription && this.insReportIdChangeSubscription.unsubscribe();
        this.buyerPropertyChangesSubscription && this.buyerPropertyChangesSubscription.unsubscribe();
        this.deleteWCCategorySubscription && this.deleteWCCategorySubscription.unsubscribe();
        this.approveWCRRSubscription && this.approveWCRRSubscription.unsubscribe();
        this.alterWCRRSubscription && this.alterWCRRSubscription.unsubscribe();
        this.updateWCRRSubscription && this.updateWCRRSubscription.unsubscribe();
    }

    getOrderDetails() {

        this.isLoading = true;

        this.orderService.getOrder(this.currentOrderId).
            then((orderResponse:any) => {

                this.isLoading = false;
                this.orderResponse = orderResponse;
                this.orderEmail = orderResponse && orderResponse.billing.email;
                //console.log('orderEmail', this.orderEmail);
            })
            .catch(() => {
                this.isLoading = false;
            })
    }
    // Check order status
    checkOrderStatus() {
        this.solutionFormService.checkOrderStatus(this.currentOrderId)
            .then((data: any) => {
                // To hide "Alter solution" button if client reviewed
                this.disableAlter = data && data.length > 0 ? true : false;
            })
    }

    //Edit category
    editCategory(category, index) {

        this.dialogRef = this.dialog.open(EditComponent, {
            width: '60%',
            panelClass: 'edit-category-dialog',
            data: {
                category: category,
                allSubCategories: this.allSubCategories,
                selectedCategories: this.categories,
                allCategories: this.checkBoxCategories,
                currentIndex: index //now mattable source changed to normal tabel (so check if index is correct before use in future)
            }
        });
        this.dialogRef.afterClosed()
            .subscribe(response => {

                if (!response) {
                    return;
                }
                const actionType: string = response[0];

                //To scroll top
                this.scrollToTop();

                switch (actionType) {
                    /**
                     * Save
                     */
                    case 'edit':

                        const formData = response[1];
                        const status: string = response[2];

                        if (status == 'success') {

                            this.toastComponent.showToast(this.toastMsg.updateSuccess);

                            const matchIndex = this.allReviewReports.indexOf(category);
                            this.allReviewReports[matchIndex].mainCategory = formData.mainCategory;
                            this.allReviewReports[matchIndex].subCategory = formData.subCategory;
                            this.allReviewReports[matchIndex].summary = formData.summary;
                            this.allReviewReports[matchIndex].totalCost = formData.totalCost;
                            this.allReviewReports[matchIndex].itemNumber = formData.itemNumber;

                            this.ngOnInit();
                            this.callParentAfterDelete.emit(); //once row edited call parent component

                        } else {
                            this.toastComponent.showToast(this.toastMsg.updateFailed);
                        }


                        break;
                }
            });
    }

    // Delete category
    deleteCategory(category) {

        // console.log('deleteCategory', category);
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.deleteCategoryConfirm;
        this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
        this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
        this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;

        this.confirmDialogRef.afterClosed().subscribe(result => {

            if (result) {
                //To scroll top
                this.scrollToTop();

                this.isLoading = true;
                this.deleteWCCategorySubscription =
                    this.reportReviewQueryService.DELETE_REPORT_REVIEW(category)
                        .subscribe(() => {

                            this.toastComponent.showToast(this.toastMsg.deleteCategory);

                            const contactIndex = this.allReviewReports.indexOf(category);
                            this.allReviewReports.splice(contactIndex, 1);

                            // Assign the data to the data source for the table to render
                            this.dataSource = new MatTableDataSource(this.allReviewReports);
                            this.dataSource.sort = this.reviewSort;

                            // If delete all review then delete stored categories also
                            if (this.allReviewReports.length == 0) {
                                this.delteAllStoredCategories();
                            }
                            else {
                                this.callParentAfterDelete.emit(); //once row deleted call parent component
                            }
                            this.isLoading = false;
                            this.ngOnInit();
                        });

            }
            this.confirmDialogRef = null;
        });
    }

    // If delete all review then delete stored categories also
    delteAllStoredCategories() {

        _.each(this.categories, (category, key) => {
            this.walkCallQueryService.DELETE_WALK_CALL(category);
            if (key + 1 == this.categories.length) {
                this.callParentApi.emit();
            }
        })
    }

    /**Approve final solution */
    approveSolution() {

        // Check solution email exist
        this.solEmail ? this.solutionEstimateEmails = [this.solEmail, this.orderEmail] : this.solutionEstimateEmails.push(this.orderEmail);

        this.emailConfirmRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            disableClose: false
        });

        this.emailConfirmRef.componentInstance.confirmMessage = this.toastMsg.editEmailConfirm;
        this.emailConfirmRef.componentInstance.confirmHead = this.toastMsg.editEmailHead;
        this.emailConfirmRef.componentInstance.confirmOkText = this.toastMsg.editEmailOk;
        this.emailConfirmRef.componentInstance.confirmCancelText = this.toastMsg.editEmailCancel;
        this.emailConfirmRef.componentInstance.emails = _.uniq(this.solutionEstimateEmails);

        this.emailConfirmRef.afterClosed().subscribe(result => {

            if (result) {
                const dialogRef = this.dialog.open(EmailPopupComponent, {
                    width: '400px',
                    data: {
                        currentOrderId: this.currentOrderId
                    }
                });
                dialogRef.afterClosed().subscribe(result => {

                    if (!result) {
                        return;
                    }

                    const actionType: string = result[0];

                    switch (actionType) {
                        /**
                         * Save
                         */
                        case 'save':
                            const alterEmail: string = result[1];
                            this.toastComponent.showToast(toastMsg.emailAddSuccess);
                            this.storeApprove(alterEmail); //pass alter email
                            break;
                        /**
                        * Failed
                        */
                        case 'failed':
                            this.toastComponent.showToast(toastMsg.emailAddFailed);
                            break;

                        case 'cancel':
                            break;

                    }

                });

            } else if (result == false) {  // if no
                this.storeApprove('');
            }
        })


    }

    storeApprove(alterEmail) {

        alterEmail ? this.solutionEstimateEmails.push(alterEmail) : this.solutionEstimateEmails = this.solutionEstimateEmails;

        _.each(this.allReviewReports, (report, key) => {

            this.approveWCRRSubscription = this.reportReviewQueryService
                .UPDATE_APPROVE_REPORT_REVIEW(report.nodeId, 'yes')
                .subscribe(() => {
                }, (err) => {
                    // Error part
                    // console.log('err', err);
                });

            if (key + 1 == this.allReviewReports.length) {

                this.toastComponent.showToast(this.toastMsg.approvedSuccess);

                this.solutionFormService.isApproveChange.next('yes');  //Once approved all set as false;

                /** Sent report id notification to client*/

                // To scroll to top 
                this.scrollToTop();
                console.log('solutionEstimateEmails', _.uniq(this.solutionEstimateEmails), this.orderResponse);
                this.solutionFormService.sentReportId(this.insReportId, this.orderResponse, this.subjectPropertyAddress, _.uniq(this.solutionEstimateEmails))
                    .then(data => {
                        this.toastComponent.showToast(this.toastMsg.mailNotifyAboutIdSuccess);
                    })
                    .catch(err => {
                        this.toastComponent.showToast(this.toastMsg.mailNotifyAboutIdFailed);

                    })

            }

        })
    }

    printValue() {
        this.dialogRef = this.dialog.open(printDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                arrayData: this.allReviewReports,
                action: 'print',
                orderType: 'walk-call'
            }
        });

    }

    /**Alter solution */
    alterSolution() {

        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.alterSolution;
        this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.alterSolutionHead;
        this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.alterSolutionOk;
        this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.alterSolutionCancel;

        // Alter solution popup opens
        this.confirmDialogRef.afterClosed().subscribe(result => {

            // if confirm
            if (result) {

                // change approve status as "no"
                _.each(this.allReviewReports, (report, key) => {

                    // Change approve status
                    this.alterWCRRSubscription = this.reportReviewQueryService
                        .UPDATE_APPROVE_REPORT_REVIEW(report.nodeId, 'no')
                        .subscribe(() => {
                        }, (err) => {
                            // Error part
                            // console.log('err', err);
                        });

                    if (key + 1 == this.allReviewReports.length) {
                        this.solutionFormService.isApproveChange.next('no');  //Once approved all set as false;
                    }
                })
            } else {
                //If cancel also 
                // To scroll to top 
                this.scrollToTop();
            }
        })

    }

    // set current paginator value
    getPaginator(key) {
        this.initalLoad = key;
        this.dragIndexChangeForReports();
    }

    // for identifying dragIndex based on paginator value -Review reoprts
    dragIndexChangeForReports() {
        this.dragIndexForReview = (Number(this.initalLoad) * (Number(this.pageNumberForReview) - 1))
    }

    //set current page
    getPage($event) {
        this.pageNumberForReview = $event;
        this.dragIndexChangeForReports();
    }

    // When drag start displayed button
    drag(event, id) {
        this.showDragSave = true;
        this.selectedId = id;

    }

    //After drop success calling save function
    transferDataSuccess($event) {
        this.save();
        this.selectedId = '';
    }

    // After drag save dragged  values
    save() {
        //To scroll top
        this.scrollToTop();
        this.isLoading = true;
        this.showDragSave = false;

        var temp1 = [];

        _.each(this.allReviewReports, (data, key) => {

            var temp = {
                mainCategory: data.mainCategory,
                subCategory: data.subCategory,
                description: data.description,
                totalCost: data.totalCost,
                summary: data.summary,
                solCategory: data.solCategory,
                solSubCategory: data.solSubCategory,
                // approve: data.approve,
                approve: 'no',
                itemNumber: data.itemNumber,
                imagePath: data.imagePath,
                subCategories: data.subCategories,
                reviewId: this.allReviewReports1[key].reviewId,
                name: data.subCategoryName ?
                    data.categoryName ?
                        data.categoryName + ':' + data.subCategoryName
                        : data.subCategoryName
                    : data.categoryName,
                id: this.allReviewReports1[key].id,
                insReportId: data.insReportId,
                nodeId: this.allReviewReports1[key].nodeId

            }
            temp1.push(temp);
            // temp1[key].mainCategory = data.mainCategory;
            // temp1[key].subCategory = data.subCategory;
            // temp1[key].description = data.description;
            // temp1[key].totalCost = data.totalCost;
            // temp1[key].summary = data.summary;
            // temp1[key].solCategory = data.solCategory;
            // temp1[key].solSubCategory = data.solSubCategory;
            // temp1[key].approve = data.approve;
            // temp1[key].itemNumber = data.itemNumber;
            // temp1[key].imagePath = data.imagePath;
            // temp1[key].name = data.subCategoryName ? data.categoryName + ':' + data.subCategoryName : data.categoryName;

            if (key + 1 == this.allReviewReports.length) {

                this.allReviewReports = temp1;
                this.saveDragSolution(this.allReviewReports);

            }
        })

    }
    // After drag save dragged  values
    saveDragSolution(allReviewReports) {

        _.each(allReviewReports, (report, key) => {
            // Change approve status 
            this.updateWCRRSubscription = this.reportReviewQueryService.UPDATE_REPORT_REVIEW_AFTER_DRAGGING_WC(report.nodeId, report)
                .subscribe((response: any) => {

                    if (key + 1 == allReviewReports.length) {
                        this.toastComponent.showToast(this.toastMsg.afterReview);
                        this.isLoading = false;
                        //To scroll top
                        this.scrollToTop();
                    }
                }, (err) => {
                    this.isLoading = false;
                    this.toastComponent.showToast(this.toastMsg.failedReview);
                    console.log('err', err);
                })

        })
    }

    // To scroll to top 
    scrollToTop() {
        const contentContainer = document.getElementById('listReport');
        contentContainer.scrollIntoView();
    }

}

export interface ReviewReport {
    mainCategory: string;
    subCategory: string;
    summary: string;
    totalCost: any;
    itemNumber: string;
    approve: string;
    insReportId: string;
    categoryName: string;
    subCategoryName: string;
    imagePath: string;
    description: string;
    solSubCategory: string;
    solCategory: String;
    name: string;
    nodeId?: string;
    subCategories?: string;
    reviewId?: string;
    id?: string;
}
export interface Categories {
    key: string;
    value: string;
    checked: boolean;
    catgoryId: number;
    callDate: Date;
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/walk-call/walk-call-body/list-reports/listReports.component.ts